export default __webpack_public_path__ + "static/media/cart_empty.2580c957.png";